import n from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _e = function e() {
  return (_e = Object.assign || function (n) {
    for (var e, a = 1, r = arguments.length; a < r; a++) {
      for (var t in e = arguments[a]) {
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }).apply(this, arguments);
},
    a = [{
  ISO2: "AW",
  ISO3: "ABW",
  name: "Aruba"
}, {
  ISO2: "AF",
  ISO3: "AFG",
  name: "Afghanistan"
}, {
  ISO2: "AO",
  ISO3: "AGO",
  name: "Angola"
}, {
  ISO2: "AI",
  ISO3: "AIA",
  name: "Anguilla"
}, {
  ISO2: "AX",
  ISO3: "ALA",
  name: "Åland Islands"
}, {
  ISO2: "AL",
  ISO3: "ALB",
  name: "Albania"
}, {
  ISO2: "AD",
  ISO3: "AND",
  name: "Andorra"
}, {
  ISO2: "AE",
  ISO3: "ARE",
  name: "United Arab Emirates"
}, {
  ISO2: "AR",
  ISO3: "ARG",
  name: "Argentina"
}, {
  ISO2: "AM",
  ISO3: "ARM",
  name: "Armenia"
}, {
  ISO2: "AS",
  ISO3: "ASM",
  name: "American Samoa"
}, {
  ISO2: "AQ",
  ISO3: "ATA",
  name: "Antarctica"
}, {
  ISO2: "TF",
  ISO3: "ATF",
  name: "French Southern and Antarctic Lands"
}, {
  ISO2: "AG",
  ISO3: "ATG",
  name: "Antigua and Barbuda"
}, {
  ISO2: "AU",
  ISO3: "AUS",
  name: "Australia"
}, {
  ISO2: "AT",
  ISO3: "AUT",
  name: "Austria"
}, {
  ISO2: "AZ",
  ISO3: "AZE",
  name: "Azerbaijan"
}, {
  ISO2: "BI",
  ISO3: "BDI",
  name: "Burundi"
}, {
  ISO2: "BE",
  ISO3: "BEL",
  name: "Belgium"
}, {
  ISO2: "BJ",
  ISO3: "BEN",
  name: "Benin"
}, {
  ISO2: "BF",
  ISO3: "BFA",
  name: "Burkina Faso"
}, {
  ISO2: "BD",
  ISO3: "BGD",
  name: "Bangladesh"
}, {
  ISO2: "BG",
  ISO3: "BGR",
  name: "Bulgaria"
}, {
  ISO2: "BH",
  ISO3: "BHR",
  name: "Bahrain"
}, {
  ISO2: "BS",
  ISO3: "BHS",
  name: "Bahamas"
}, {
  ISO2: "BA",
  ISO3: "BIH",
  name: "Bosnia and Herzegovina"
}, {
  ISO2: "BL",
  ISO3: "BLM",
  name: "Saint Barthélemy"
}, {
  ISO2: "SH",
  ISO3: "SHN",
  name: "Saint Helena, Ascension and Tristan da Cunha"
}, {
  ISO2: "BY",
  ISO3: "BLR",
  name: "Belarus"
}, {
  ISO2: "BZ",
  ISO3: "BLZ",
  name: "Belize"
}, {
  ISO2: "BM",
  ISO3: "BMU",
  name: "Bermuda"
}, {
  ISO2: "BO",
  ISO3: "BOL",
  name: "Bolivia"
}, {
  ISO2: "BQ",
  ISO3: "BES",
  name: "Caribbean Netherlands"
}, {
  ISO2: "BR",
  ISO3: "BRA",
  name: "Brazil"
}, {
  ISO2: "BB",
  ISO3: "BRB",
  name: "Barbados"
}, {
  ISO2: "BN",
  ISO3: "BRN",
  name: "Brunei"
}, {
  ISO2: "BT",
  ISO3: "BTN",
  name: "Bhutan"
}, {
  ISO2: "BV",
  ISO3: "BVT",
  name: "Bouvet Island"
}, {
  ISO2: "BW",
  ISO3: "BWA",
  name: "Botswana"
}, {
  ISO2: "CF",
  ISO3: "CAF",
  name: "Central African Republic"
}, {
  ISO2: "CA",
  ISO3: "CAN",
  name: "Canada"
}, {
  ISO2: "CC",
  ISO3: "CCK",
  name: "Cocos (Keeling) Islands"
}, {
  ISO2: "CH",
  ISO3: "CHE",
  name: "Switzerland"
}, {
  ISO2: "CL",
  ISO3: "CHL",
  name: "Chile"
}, {
  ISO2: "CN",
  ISO3: "CHN",
  name: "China"
}, {
  ISO2: "CI",
  ISO3: "CIV",
  name: "Ivory Coast"
}, {
  ISO2: "CM",
  ISO3: "CMR",
  name: "Cameroon"
}, {
  ISO2: "CD",
  ISO3: "COD",
  name: "DR Congo"
}, {
  ISO2: "CG",
  ISO3: "COG",
  name: "Republic of the Congo"
}, {
  ISO2: "CK",
  ISO3: "COK",
  name: "Cook Islands"
}, {
  ISO2: "CO",
  ISO3: "COL",
  name: "Colombia"
}, {
  ISO2: "KM",
  ISO3: "COM",
  name: "Comoros"
}, {
  ISO2: "CV",
  ISO3: "CPV",
  name: "Cape Verde"
}, {
  ISO2: "CR",
  ISO3: "CRI",
  name: "Costa Rica"
}, {
  ISO2: "CU",
  ISO3: "CUB",
  name: "Cuba"
}, {
  ISO2: "CW",
  ISO3: "CUW",
  name: "Curaçao"
}, {
  ISO2: "CX",
  ISO3: "CXR",
  name: "Christmas Island"
}, {
  ISO2: "KY",
  ISO3: "CYM",
  name: "Cayman Islands"
}, {
  ISO2: "CY",
  ISO3: "CYP",
  name: "Cyprus"
}, {
  ISO2: "CZ",
  ISO3: "CZE",
  name: "Czechia"
}, {
  ISO2: "DE",
  ISO3: "DEU",
  name: "Germany"
}, {
  ISO2: "DJ",
  ISO3: "DJI",
  name: "Djibouti"
}, {
  ISO2: "DM",
  ISO3: "DMA",
  name: "Dominica"
}, {
  ISO2: "DK",
  ISO3: "DNK",
  name: "Denmark"
}, {
  ISO2: "DO",
  ISO3: "DOM",
  name: "Dominican Republic"
}, {
  ISO2: "DZ",
  ISO3: "DZA",
  name: "Algeria"
}, {
  ISO2: "EC",
  ISO3: "ECU",
  name: "Ecuador"
}, {
  ISO2: "EG",
  ISO3: "EGY",
  name: "Egypt"
}, {
  ISO2: "ER",
  ISO3: "ERI",
  name: "Eritrea"
}, {
  ISO2: "EH",
  ISO3: "ESH",
  name: "Western Sahara"
}, {
  ISO2: "ES",
  ISO3: "ESP",
  name: "Spain"
}, {
  ISO2: "EE",
  ISO3: "EST",
  name: "Estonia"
}, {
  ISO2: "ET",
  ISO3: "ETH",
  name: "Ethiopia"
}, {
  ISO2: "FI",
  ISO3: "FIN",
  name: "Finland"
}, {
  ISO2: "FJ",
  ISO3: "FJI",
  name: "Fiji"
}, {
  ISO2: "FK",
  ISO3: "FLK",
  name: "Falkland Islands"
}, {
  ISO2: "FR",
  ISO3: "FRA",
  name: "France"
}, {
  ISO2: "FO",
  ISO3: "FRO",
  name: "Faroe Islands"
}, {
  ISO2: "FM",
  ISO3: "FSM",
  name: "Micronesia"
}, {
  ISO2: "GA",
  ISO3: "GAB",
  name: "Gabon"
}, {
  ISO2: "GB",
  ISO3: "GBR",
  name: "United Kingdom"
}, {
  ISO2: "GE",
  ISO3: "GEO",
  name: "Georgia"
}, {
  ISO2: "GG",
  ISO3: "GGY",
  name: "Guernsey"
}, {
  ISO2: "GH",
  ISO3: "GHA",
  name: "Ghana"
}, {
  ISO2: "GI",
  ISO3: "GIB",
  name: "Gibraltar"
}, {
  ISO2: "GN",
  ISO3: "GIN",
  name: "Guinea"
}, {
  ISO2: "GP",
  ISO3: "GLP",
  name: "Guadeloupe"
}, {
  ISO2: "GM",
  ISO3: "GMB",
  name: "Gambia"
}, {
  ISO2: "GW",
  ISO3: "GNB",
  name: "Guinea-Bissau"
}, {
  ISO2: "GQ",
  ISO3: "GNQ",
  name: "Equatorial Guinea"
}, {
  ISO2: "GR",
  ISO3: "GRC",
  name: "Greece"
}, {
  ISO2: "GD",
  ISO3: "GRD",
  name: "Grenada"
}, {
  ISO2: "GL",
  ISO3: "GRL",
  name: "Greenland"
}, {
  ISO2: "GT",
  ISO3: "GTM",
  name: "Guatemala"
}, {
  ISO2: "GF",
  ISO3: "GUF",
  name: "French Guiana"
}, {
  ISO2: "GU",
  ISO3: "GUM",
  name: "Guam"
}, {
  ISO2: "GY",
  ISO3: "GUY",
  name: "Guyana"
}, {
  ISO2: "HK",
  ISO3: "HKG",
  name: "Hong Kong"
}, {
  ISO2: "HM",
  ISO3: "HMD",
  name: "Heard Island and McDonald Islands"
}, {
  ISO2: "HN",
  ISO3: "HND",
  name: "Honduras"
}, {
  ISO2: "HR",
  ISO3: "HRV",
  name: "Croatia"
}, {
  ISO2: "HT",
  ISO3: "HTI",
  name: "Haiti"
}, {
  ISO2: "HU",
  ISO3: "HUN",
  name: "Hungary"
}, {
  ISO2: "ID",
  ISO3: "IDN",
  name: "Indonesia"
}, {
  ISO2: "IM",
  ISO3: "IMN",
  name: "Isle of Man"
}, {
  ISO2: "IN",
  ISO3: "IND",
  name: "India"
}, {
  ISO2: "IO",
  ISO3: "IOT",
  name: "British Indian Ocean Territory"
}, {
  ISO2: "IE",
  ISO3: "IRL",
  name: "Ireland"
}, {
  ISO2: "IR",
  ISO3: "IRN",
  name: "Iran"
}, {
  ISO2: "IQ",
  ISO3: "IRQ",
  name: "Iraq"
}, {
  ISO2: "IS",
  ISO3: "ISL",
  name: "Iceland"
}, {
  ISO2: "IL",
  ISO3: "ISR",
  name: "Israel"
}, {
  ISO2: "IT",
  ISO3: "ITA",
  name: "Italy"
}, {
  ISO2: "JM",
  ISO3: "JAM",
  name: "Jamaica"
}, {
  ISO2: "JE",
  ISO3: "JEY",
  name: "Jersey"
}, {
  ISO2: "JO",
  ISO3: "JOR",
  name: "Jordan"
}, {
  ISO2: "JP",
  ISO3: "JPN",
  name: "Japan"
}, {
  ISO2: "KZ",
  ISO3: "KAZ",
  name: "Kazakhstan"
}, {
  ISO2: "KE",
  ISO3: "KEN",
  name: "Kenya"
}, {
  ISO2: "KG",
  ISO3: "KGZ",
  name: "Kyrgyzstan"
}, {
  ISO2: "KH",
  ISO3: "KHM",
  name: "Cambodia"
}, {
  ISO2: "KI",
  ISO3: "KIR",
  name: "Kiribati"
}, {
  ISO2: "KN",
  ISO3: "KNA",
  name: "Saint Kitts and Nevis"
}, {
  ISO2: "KR",
  ISO3: "KOR",
  name: "South Korea"
}, {
  ISO2: "XK",
  ISO3: "UNK",
  name: "Kosovo"
}, {
  ISO2: "KW",
  ISO3: "KWT",
  name: "Kuwait"
}, {
  ISO2: "LA",
  ISO3: "LAO",
  name: "Laos"
}, {
  ISO2: "LB",
  ISO3: "LBN",
  name: "Lebanon"
}, {
  ISO2: "LR",
  ISO3: "LBR",
  name: "Liberia"
}, {
  ISO2: "LY",
  ISO3: "LBY",
  name: "Libya"
}, {
  ISO2: "LC",
  ISO3: "LCA",
  name: "Saint Lucia"
}, {
  ISO2: "LI",
  ISO3: "LIE",
  name: "Liechtenstein"
}, {
  ISO2: "LK",
  ISO3: "LKA",
  name: "Sri Lanka"
}, {
  ISO2: "LS",
  ISO3: "LSO",
  name: "Lesotho"
}, {
  ISO2: "LT",
  ISO3: "LTU",
  name: "Lithuania"
}, {
  ISO2: "LU",
  ISO3: "LUX",
  name: "Luxembourg"
}, {
  ISO2: "LV",
  ISO3: "LVA",
  name: "Latvia"
}, {
  ISO2: "MO",
  ISO3: "MAC",
  name: "Macau"
}, {
  ISO2: "MF",
  ISO3: "MAF",
  name: "Saint Martin"
}, {
  ISO2: "MA",
  ISO3: "MAR",
  name: "Morocco"
}, {
  ISO2: "MC",
  ISO3: "MCO",
  name: "Monaco"
}, {
  ISO2: "MD",
  ISO3: "MDA",
  name: "Moldova"
}, {
  ISO2: "MG",
  ISO3: "MDG",
  name: "Madagascar"
}, {
  ISO2: "MV",
  ISO3: "MDV",
  name: "Maldives"
}, {
  ISO2: "MX",
  ISO3: "MEX",
  name: "Mexico"
}, {
  ISO2: "MH",
  ISO3: "MHL",
  name: "Marshall Islands"
}, {
  ISO2: "MK",
  ISO3: "MKD",
  name: "North Macedonia"
}, {
  ISO2: "ML",
  ISO3: "MLI",
  name: "Mali"
}, {
  ISO2: "MT",
  ISO3: "MLT",
  name: "Malta"
}, {
  ISO2: "MM",
  ISO3: "MMR",
  name: "Myanmar"
}, {
  ISO2: "ME",
  ISO3: "MNE",
  name: "Montenegro"
}, {
  ISO2: "MN",
  ISO3: "MNG",
  name: "Mongolia"
}, {
  ISO2: "MP",
  ISO3: "MNP",
  name: "Northern Mariana Islands"
}, {
  ISO2: "MZ",
  ISO3: "MOZ",
  name: "Mozambique"
}, {
  ISO2: "MR",
  ISO3: "MRT",
  name: "Mauritania"
}, {
  ISO2: "MS",
  ISO3: "MSR",
  name: "Montserrat"
}, {
  ISO2: "MQ",
  ISO3: "MTQ",
  name: "Martinique"
}, {
  ISO2: "MU",
  ISO3: "MUS",
  name: "Mauritius"
}, {
  ISO2: "MW",
  ISO3: "MWI",
  name: "Malawi"
}, {
  ISO2: "MY",
  ISO3: "MYS",
  name: "Malaysia"
}, {
  ISO2: "YT",
  ISO3: "MYT",
  name: "Mayotte"
}, {
  ISO2: "NA",
  ISO3: "NAM",
  name: "Namibia"
}, {
  ISO2: "NC",
  ISO3: "NCL",
  name: "New Caledonia"
}, {
  ISO2: "NE",
  ISO3: "NER",
  name: "Niger"
}, {
  ISO2: "NF",
  ISO3: "NFK",
  name: "Norfolk Island"
}, {
  ISO2: "NG",
  ISO3: "NGA",
  name: "Nigeria"
}, {
  ISO2: "NI",
  ISO3: "NIC",
  name: "Nicaragua"
}, {
  ISO2: "NU",
  ISO3: "NIU",
  name: "Niue"
}, {
  ISO2: "NL",
  ISO3: "NLD",
  name: "Netherlands"
}, {
  ISO2: "NO",
  ISO3: "NOR",
  name: "Norway"
}, {
  ISO2: "NP",
  ISO3: "NPL",
  name: "Nepal"
}, {
  ISO2: "NR",
  ISO3: "NRU",
  name: "Nauru"
}, {
  ISO2: "NZ",
  ISO3: "NZL",
  name: "New Zealand"
}, {
  ISO2: "OM",
  ISO3: "OMN",
  name: "Oman"
}, {
  ISO2: "PK",
  ISO3: "PAK",
  name: "Pakistan"
}, {
  ISO2: "PA",
  ISO3: "PAN",
  name: "Panama"
}, {
  ISO2: "PN",
  ISO3: "PCN",
  name: "Pitcairn Islands"
}, {
  ISO2: "PE",
  ISO3: "PER",
  name: "Peru"
}, {
  ISO2: "PH",
  ISO3: "PHL",
  name: "Philippines"
}, {
  ISO2: "PW",
  ISO3: "PLW",
  name: "Palau"
}, {
  ISO2: "PG",
  ISO3: "PNG",
  name: "Papua New Guinea"
}, {
  ISO2: "PL",
  ISO3: "POL",
  name: "Poland"
}, {
  ISO2: "PR",
  ISO3: "PRI",
  name: "Puerto Rico"
}, {
  ISO2: "KP",
  ISO3: "PRK",
  name: "North Korea"
}, {
  ISO2: "PT",
  ISO3: "PRT",
  name: "Portugal"
}, {
  ISO2: "PY",
  ISO3: "PRY",
  name: "Paraguay"
}, {
  ISO2: "PS",
  ISO3: "PSE",
  name: "Palestine"
}, {
  ISO2: "PF",
  ISO3: "PYF",
  name: "French Polynesia"
}, {
  ISO2: "QA",
  ISO3: "QAT",
  name: "Qatar"
}, {
  ISO2: "RE",
  ISO3: "REU",
  name: "Réunion"
}, {
  ISO2: "RO",
  ISO3: "ROU",
  name: "Romania"
}, {
  ISO2: "RU",
  ISO3: "RUS",
  name: "Russia"
}, {
  ISO2: "RW",
  ISO3: "RWA",
  name: "Rwanda"
}, {
  ISO2: "SA",
  ISO3: "SAU",
  name: "Saudi Arabia"
}, {
  ISO2: "SD",
  ISO3: "SDN",
  name: "Sudan"
}, {
  ISO2: "SN",
  ISO3: "SEN",
  name: "Senegal"
}, {
  ISO2: "SG",
  ISO3: "SGP",
  name: "Singapore"
}, {
  ISO2: "GS",
  ISO3: "SGS",
  name: "South Georgia"
}, {
  ISO2: "SJ",
  ISO3: "SJM",
  name: "Svalbard and Jan Mayen"
}, {
  ISO2: "SB",
  ISO3: "SLB",
  name: "Solomon Islands"
}, {
  ISO2: "SL",
  ISO3: "SLE",
  name: "Sierra Leone"
}, {
  ISO2: "SV",
  ISO3: "SLV",
  name: "El Salvador"
}, {
  ISO2: "SM",
  ISO3: "SMR",
  name: "San Marino"
}, {
  ISO2: "SO",
  ISO3: "SOM",
  name: "Somalia"
}, {
  ISO2: "PM",
  ISO3: "SPM",
  name: "Saint Pierre and Miquelon"
}, {
  ISO2: "RS",
  ISO3: "SRB",
  name: "Serbia"
}, {
  ISO2: "SS",
  ISO3: "SSD",
  name: "South Sudan"
}, {
  ISO2: "ST",
  ISO3: "STP",
  name: "São Tomé and Príncipe"
}, {
  ISO2: "SR",
  ISO3: "SUR",
  name: "Suriname"
}, {
  ISO2: "SK",
  ISO3: "SVK",
  name: "Slovakia"
}, {
  ISO2: "SI",
  ISO3: "SVN",
  name: "Slovenia"
}, {
  ISO2: "SE",
  ISO3: "SWE",
  name: "Sweden"
}, {
  ISO2: "SZ",
  ISO3: "SWZ",
  name: "Eswatini"
}, {
  ISO2: "SX",
  ISO3: "SXM",
  name: "Sint Maarten"
}, {
  ISO2: "SC",
  ISO3: "SYC",
  name: "Seychelles"
}, {
  ISO2: "SY",
  ISO3: "SYR",
  name: "Syria"
}, {
  ISO2: "TC",
  ISO3: "TCA",
  name: "Turks and Caicos Islands"
}, {
  ISO2: "TD",
  ISO3: "TCD",
  name: "Chad"
}, {
  ISO2: "TG",
  ISO3: "TGO",
  name: "Togo"
}, {
  ISO2: "TH",
  ISO3: "THA",
  name: "Thailand"
}, {
  ISO2: "TJ",
  ISO3: "TJK",
  name: "Tajikistan"
}, {
  ISO2: "TK",
  ISO3: "TKL",
  name: "Tokelau"
}, {
  ISO2: "TM",
  ISO3: "TKM",
  name: "Turkmenistan"
}, {
  ISO2: "TL",
  ISO3: "TLS",
  name: "Timor-Leste"
}, {
  ISO2: "TO",
  ISO3: "TON",
  name: "Tonga"
}, {
  ISO2: "TT",
  ISO3: "TTO",
  name: "Trinidad and Tobago"
}, {
  ISO2: "TN",
  ISO3: "TUN",
  name: "Tunisia"
}, {
  ISO2: "TR",
  ISO3: "TUR",
  name: "Turkey"
}, {
  ISO2: "TV",
  ISO3: "TUV",
  name: "Tuvalu"
}, {
  ISO2: "TW",
  ISO3: "TAI",
  name: "Chinese Taipei"
}, {
  ISO2: "TZ",
  ISO3: "TZA",
  name: "Tanzania"
}, {
  ISO2: "UG",
  ISO3: "UGA",
  name: "Uganda"
}, {
  ISO2: "UA",
  ISO3: "UKR",
  name: "Ukraine"
}, {
  ISO2: "UM",
  ISO3: "UMI",
  name: "United States Minor Outlying Islands"
}, {
  ISO2: "UY",
  ISO3: "URY",
  name: "Uruguay"
}, {
  ISO2: "US",
  ISO3: "USA",
  name: "United States"
}, {
  ISO2: "UZ",
  ISO3: "UZB",
  name: "Uzbekistan"
}, {
  ISO2: "VA",
  ISO3: "VAT",
  name: "Vatican City"
}, {
  ISO2: "VC",
  ISO3: "VCT",
  name: "Saint Vincent and the Grenadines"
}, {
  ISO2: "VE",
  ISO3: "VEN",
  name: "Venezuela"
}, {
  ISO2: "VG",
  ISO3: "VGB",
  name: "British Virgin Islands"
}, {
  ISO2: "VI",
  ISO3: "VIR",
  name: "United States Virgin Islands"
}, {
  ISO2: "VN",
  ISO3: "VNM",
  name: "Vietnam"
}, {
  ISO2: "VU",
  ISO3: "VUT",
  name: "Vanuatu"
}, {
  ISO2: "WF",
  ISO3: "WLF",
  name: "Wallis and Futuna"
}, {
  ISO2: "WS",
  ISO3: "WSM",
  name: "Samoa"
}, {
  ISO2: "YE",
  ISO3: "YEM",
  name: "Yemen"
}, {
  ISO2: "ZA",
  ISO3: "ZAF",
  name: "South Africa"
}, {
  ISO2: "ZM",
  ISO3: "ZMB",
  name: "Zambia"
}, {
  ISO2: "ZW",
  ISO3: "ZWE",
  name: "Zimbabwe"
}],
    r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function t(n, e) {
  return n(e = {
    exports: {}
  }, e.exports), e.exports;
}

var S,
    I,
    O,
    o = t(function (n, e) {
  var a, r;
  n.exports = (a = function a(n) {
    return Array.prototype.toString.call(n);
  }, r = function r(n, e) {
    try {
      var a = document.createElement("canvas");
      a.width = 1, a.height = 1;
      var r = a.getContext("2d");
      return r.textBaseline = "top", r.font = "100px -no-font-family-here-", r.fillStyle = e, r.scale(.01, .01), r.fillText(n, 0, 0), r.getImageData(0, 0, 1, 1).data;
    } catch (n) {
      return !1;
    }
  }, function (n) {
    var e = r(n, "#000"),
        t = r(n, "#fff");
    return e && t && function (n, e) {
      var r = a(n);
      return r === a(e) && "0,0,0,0" !== r;
    }(e, t);
  });
}),
    i = "object",
    u = function u(n) {
  return n && n.Math == Math && n;
},
    m = u(typeof globalThis == i && globalThis) || u(typeof window == i && window) || u(typeof self == i && self) || u(typeof r == i && r) || Function("return this")(),
    c = function c(n) {
  try {
    return !!n();
  } catch (n) {
    return !0;
  }
},
    l = !c(function () {
  return 7 != Object.defineProperty({}, "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    s = {}.propertyIsEnumerable,
    f = Object.getOwnPropertyDescriptor,
    d = {
  f: f && !s.call({
    1: 2
  }, 1) ? function (n) {
    var e = f(this, n);
    return !!e && e.enumerable;
  } : s
},
    p = function p(n, e) {
  return {
    enumerable: !(1 & n),
    configurable: !(2 & n),
    writable: !(4 & n),
    value: e
  };
},
    g = {}.toString,
    M = function M(n) {
  return g.call(n).slice(8, -1);
},
    h = "".split,
    y = c(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (n) {
  return "String" == M(n) ? h.call(n, "") : Object(n);
} : Object,
    A = function A(n) {
  if (null == n) throw TypeError("Can't call method on " + n);
  return n;
},
    C = function C(n) {
  return y(A(n));
},
    v = function v(n) {
  return "object" == typeof n ? null !== n : "function" == typeof n;
},
    T = function T(n, e) {
  if (!v(n)) return n;
  var a, r;
  if (e && "function" == typeof (a = n.toString) && !v(r = a.call(n))) return r;
  if ("function" == typeof (a = n.valueOf) && !v(r = a.call(n))) return r;
  if (!e && "function" == typeof (a = n.toString) && !v(r = a.call(n))) return r;
  throw TypeError("Can't convert object to primitive value");
},
    N = {}.hasOwnProperty,
    G = function G(n, e) {
  return N.call(n, e);
},
    B = m.document,
    R = v(B) && v(B.createElement),
    E = function E(n) {
  return R ? B.createElement(n) : {};
},
    b = !l && !c(function () {
  return 7 != Object.defineProperty(E("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    L = Object.getOwnPropertyDescriptor,
    P = {
  f: l ? L : function (n, e) {
    if (n = C(n), e = T(e, !0), b) try {
      return L(n, e);
    } catch (n) {}
    if (G(n, e)) return p(!d.f.call(n, e), n[e]);
  }
},
    K = function K(n) {
  if (!v(n)) throw TypeError(String(n) + " is not an object");
  return n;
},
    U = Object.defineProperty,
    w = {
  f: l ? U : function (n, e, a) {
    if (K(n), e = T(e, !0), K(a), b) try {
      return U(n, e, a);
    } catch (n) {}
    if ("get" in a || "set" in a) throw TypeError("Accessors not supported");
    return "value" in a && (n[e] = a.value), n;
  }
},
    F = l ? function (n, e, a) {
  return w.f(n, e, p(1, a));
} : function (n, e, a) {
  return n[e] = a, n;
},
    D = function D(n, e) {
  try {
    F(m, n, e);
  } catch (a) {
    m[n] = e;
  }

  return e;
},
    H = t(function (n) {
  var e = m["__core-js_shared__"] || D("__core-js_shared__", {});
  (n.exports = function (n, a) {
    return e[n] || (e[n] = void 0 !== a ? a : {});
  })("versions", []).push({
    version: "3.1.3",
    mode: "global",
    copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
  });
}),
    V = H("native-function-to-string", Function.toString),
    j = m.WeakMap,
    W = "function" == typeof j && /native code/.test(V.call(j)),
    Z = 0,
    Y = Math.random(),
    k = function k(n) {
  return "Symbol(" + String(void 0 === n ? "" : n) + ")_" + (++Z + Y).toString(36);
},
    J = H("keys"),
    x = function x(n) {
  return J[n] || (J[n] = k(n));
},
    z = {},
    _ = m.WeakMap;

if (W) {
  var Q = new _(),
      X = Q.get,
      q = Q.has,
      $ = Q.set;
  S = function S(n, e) {
    return $.call(Q, n, e), e;
  }, I = function I(n) {
    return X.call(Q, n) || {};
  }, O = function O(n) {
    return q.call(Q, n);
  };
} else {
  var nn = x("state");
  z[nn] = !0, S = function S(n, e) {
    return F(n, nn, e), e;
  }, I = function I(n) {
    return G(n, nn) ? n[nn] : {};
  }, O = function O(n) {
    return G(n, nn);
  };
}

var en = {
  set: S,
  get: I,
  has: O,
  enforce: function enforce(n) {
    return O(n) ? I(n) : S(n, {});
  },
  getterFor: function getterFor(n) {
    return function (e) {
      var a;
      if (!v(e) || (a = I(e)).type !== n) throw TypeError("Incompatible receiver, " + n + " required");
      return a;
    };
  }
},
    an = t(function (n) {
  var e = en.get,
      a = en.enforce,
      r = String(V).split("toString");
  H("inspectSource", function (n) {
    return V.call(n);
  }), (n.exports = function (n, e, t, S) {
    var I = !!S && !!S.unsafe,
        O = !!S && !!S.enumerable,
        o = !!S && !!S.noTargetGet;
    "function" == typeof t && ("string" != typeof e || G(t, "name") || F(t, "name", e), a(t).source = r.join("string" == typeof e ? e : "")), n !== m ? (I ? !o && n[e] && (O = !0) : delete n[e], O ? n[e] = t : F(n, e, t)) : O ? n[e] = t : D(e, t);
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && e(this).source || V.call(this);
  });
}),
    rn = m,
    tn = function tn(n) {
  return "function" == typeof n ? n : void 0;
},
    Sn = function Sn(n, e) {
  return arguments.length < 2 ? tn(rn[n]) || tn(m[n]) : rn[n] && rn[n][e] || m[n] && m[n][e];
},
    In = Math.ceil,
    On = Math.floor,
    on = function on(n) {
  return isNaN(n = +n) ? 0 : (n > 0 ? On : In)(n);
},
    un = Math.min,
    mn = function mn(n) {
  return n > 0 ? un(on(n), 9007199254740991) : 0;
},
    cn = Math.max,
    ln = Math.min,
    sn = function sn(n, e) {
  var a = on(n);
  return a < 0 ? cn(a + e, 0) : ln(a, e);
},
    fn = function fn(n) {
  return function (e, a, r) {
    var t,
        S = C(e),
        I = mn(S.length),
        O = sn(r, I);

    if (n && a != a) {
      for (; I > O;) {
        if ((t = S[O++]) != t) return !0;
      }
    } else for (; I > O; O++) {
      if ((n || O in S) && S[O] === a) return n || O || 0;
    }

    return !n && -1;
  };
},
    dn = (fn(!0), fn(!1)),
    pn = function pn(n, e) {
  var a,
      r = C(n),
      t = 0,
      S = [];

  for (a in r) {
    !G(z, a) && G(r, a) && S.push(a);
  }

  for (; e.length > t;) {
    G(r, a = e[t++]) && (~dn(S, a) || S.push(a));
  }

  return S;
},
    gn = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    Mn = gn.concat("length", "prototype"),
    hn = {
  f: Object.getOwnPropertyNames || function (n) {
    return pn(n, Mn);
  }
},
    yn = {
  f: Object.getOwnPropertySymbols
},
    An = Sn("Reflect", "ownKeys") || function (n) {
  var e = hn.f(K(n)),
      a = yn.f;
  return a ? e.concat(a(n)) : e;
},
    Cn = function Cn(n, e) {
  for (var a = An(e), r = w.f, t = P.f, S = 0; S < a.length; S++) {
    var I = a[S];
    G(n, I) || r(n, I, t(e, I));
  }
},
    vn = /#|\.prototype\./,
    Tn = function Tn(n, e) {
  var a = Gn[Nn(n)];
  return a == Rn || a != Bn && ("function" == typeof e ? c(e) : !!e);
},
    Nn = Tn.normalize = function (n) {
  return String(n).replace(vn, ".").toLowerCase();
},
    Gn = Tn.data = {},
    Bn = Tn.NATIVE = "N",
    Rn = Tn.POLYFILL = "P",
    En = Tn,
    bn = P.f,
    Ln = function Ln(n, e) {
  var a,
      r,
      t,
      S,
      I,
      O = n.target,
      o = n.global,
      i = n.stat;
  if (a = o ? m : i ? m[O] || D(O, {}) : (m[O] || {}).prototype) for (r in e) {
    if (S = e[r], t = n.noTargetGet ? (I = bn(a, r)) && I.value : a[r], !En(o ? r : O + (i ? "." : "#") + r, n.forced) && void 0 !== t) {
      if (typeof S == typeof t) continue;
      Cn(S, t);
    }

    (n.sham || t && t.sham) && F(S, "sham", !0), an(a, r, S, n);
  }
},
    Pn = String.fromCharCode,
    Kn = String.fromCodePoint;

Ln({
  target: "String",
  stat: !0,
  forced: !!Kn && 1 != Kn.length
}, {
  fromCodePoint: function fromCodePoint(n) {
    for (var e, a = [], r = arguments.length, t = 0; r > t;) {
      if (e = +arguments[t++], sn(e, 1114111) !== e) throw RangeError(e + " is not a valid code point");
      a.push(e < 65536 ? Pn(e) : Pn(55296 + ((e -= 65536) >> 10), e % 1024 + 56320));
    }

    return a.join("");
  }
}), rn.String.fromCodePoint;

var Un = function Un(n) {
  return function (e, a) {
    var r,
        t,
        S = String(A(e)),
        I = on(a),
        O = S.length;
    return I < 0 || I >= O ? n ? "" : void 0 : (r = S.charCodeAt(I)) < 55296 || r > 56319 || I + 1 === O || (t = S.charCodeAt(I + 1)) < 56320 || t > 57343 ? n ? S.charAt(I) : r : n ? S.slice(I, I + 2) : t - 56320 + (r - 55296 << 10) + 65536;
  };
},
    wn = [Un(!1), Un(!0)][0];

Ln({
  target: "String",
  proto: !0
}, {
  codePointAt: function codePointAt(n) {
    return wn(this, n);
  }
});

var Fn = function Fn(n, e, a) {
  if (function (n) {
    if ("function" != typeof n) throw TypeError(String(n) + " is not a function");
  }(n), void 0 === e) return n;

  switch (a) {
    case 0:
      return function () {
        return n.call(e);
      };

    case 1:
      return function (a) {
        return n.call(e, a);
      };

    case 2:
      return function (a, r) {
        return n.call(e, a, r);
      };

    case 3:
      return function (a, r, t) {
        return n.call(e, a, r, t);
      };
  }

  return function () {
    return n.apply(e, arguments);
  };
},
    Dn = Function.call,
    Hn = function Hn(n, e, a) {
  return Fn(Dn, m[n].prototype[e], a);
};

Hn("String", "codePointAt"), Ln({
  target: "String",
  proto: !0
}, {
  repeat: "".repeat || function (n) {
    var e = String(A(this)),
        a = "",
        r = on(n);
    if (r < 0 || r == 1 / 0) throw RangeError("Wrong number of repetitions");

    for (; r > 0; (r >>>= 1) && (e += e)) {
      1 & r && (a += e);
    }

    return a;
  }
}), Hn("String", "repeat");

var Vn = Array.isArray || function (n) {
  return "Array" == M(n);
},
    jn = !!Object.getOwnPropertySymbols && !c(function () {
  return !String(Symbol());
}),
    Wn = m.Symbol,
    Zn = H("wks"),
    Yn = function Yn(n) {
  return Zn[n] || (Zn[n] = jn && Wn[n] || (jn ? Wn : k)("Symbol." + n));
},
    kn = Yn("species"),
    Jn = function Jn(n, e) {
  var a;
  return Vn(n) && ("function" != typeof (a = n.constructor) || a !== Array && !Vn(a.prototype) ? v(a) && null === (a = a[kn]) && (a = void 0) : a = void 0), new (void 0 === a ? Array : a)(0 === e ? 0 : e);
},
    xn = [].push,
    zn = function zn(n) {
  var e = 1 == n,
      a = 2 == n,
      r = 3 == n,
      t = 4 == n,
      S = 6 == n,
      I = 5 == n || S;
  return function (O, o, i, u) {
    for (var m, c, l = Object(A(O)), s = y(l), f = Fn(o, i, 3), d = mn(s.length), p = 0, g = u || Jn, M = e ? g(O, d) : a ? g(O, 0) : void 0; d > p; p++) {
      if ((I || p in s) && (c = f(m = s[p], p, l), n)) if (e) M[p] = c;else if (c) switch (n) {
        case 3:
          return !0;

        case 5:
          return m;

        case 6:
          return p;

        case 2:
          xn.call(M, m);
      } else if (t) return !1;
    }

    return S ? -1 : r || t ? t : M;
  };
},
    _n = {
  forEach: zn(0),
  map: zn(1),
  filter: zn(2),
  some: zn(3),
  every: zn(4),
  find: zn(5),
  findIndex: zn(6)
},
    Qn = Object.keys || function (n) {
  return pn(n, gn);
},
    Xn = l ? Object.defineProperties : function (n, e) {
  K(n);

  for (var a, r = Qn(e), t = r.length, S = 0; t > S;) {
    w.f(n, a = r[S++], e[a]);
  }

  return n;
},
    qn = Sn("document", "documentElement"),
    $n = x("IE_PROTO"),
    ne = function ne() {},
    _ee = function ee() {
  var n,
      e = E("iframe"),
      a = gn.length;

  for (e.style.display = "none", qn.appendChild(e), e.src = String("javascript:"), (n = e.contentWindow.document).open(), n.write("<script>document.F=Object<\/script>"), n.close(), _ee = n.F; a--;) {
    delete _ee.prototype[gn[a]];
  }

  return _ee();
},
    ae = Object.create || function (n, e) {
  var a;
  return null !== n ? (ne.prototype = K(n), a = new ne(), ne.prototype = null, a[$n] = n) : a = _ee(), void 0 === e ? a : Xn(a, e);
};

z[$n] = !0;
var re = Yn("unscopables"),
    te = Array.prototype;
null == te[re] && F(te, re, ae(null));
var Se = _n.find,
    Ie = !0;
"find" in [] && Array(1).find(function () {
  Ie = !1;
}), Ln({
  target: "Array",
  proto: !0,
  forced: Ie
}, {
  find: function find(n) {
    return Se(this, n, arguments.length > 1 ? arguments[1] : void 0);
  }
}), te[re].find = !0, Hn("Array", "find");
var Oe = o("🇧🇹");

var oe = function oe(r) {
  var t = r.iso,
      S = r.svg,
      I = void 0 !== S && S,
      O = r.svgBorder,
      o = void 0 !== O && O,
      i = r.className,
      u = void 0 === i ? "" : i,
      m = r.size,
      c = void 0 === m ? "1em" : m,
      l = r.margin,
      s = void 0 === l ? {
    left: "0.1em",
    right: "0.2em"
  } : l;
  if (!t) return console.error(" Country flag iso (iso 3) or iso2 code is required"), null;
  var f = null;

  try {
    f = function (n) {
      var e, r, t;

      if (2 === n.length) {
        if (e = n.toLowerCase(), r = e.toUpperCase(), void 0 === (t = a.find(function (n) {
          return n.ISO2 === r;
        }))) throw new Error("Could not find a country corresponding to provided ISO: " + n);
      } else {
        if (3 !== n.length) throw new Error(n + " is not an ISO 2 nor ISO 3 code");
        var S = n.toUpperCase();
        if (void 0 === (t = a.find(function (n) {
          return n.ISO3 === S;
        }))) throw new Error("Could not find a country corresponding to provided ISO: " + n);
        e = (r = t.ISO2).toLowerCase();
      }

      var I = null;

      if (Oe && r) {
        var O = r.codePointAt(0),
            o = r.codePointAt(1);
        O && o && (I = String.fromCodePoint(O + 127397, o + 127397));
      }

      return {
        emoji: I,
        svg: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/4x3/{iso2}.svg".replace("{iso2}", e),
        name: t.name
      };
    }(t);
  } catch (n) {
    console.warn("Country flag error, incorrect iso code for:", t);
  }

  return f ? !0 === I || null === f.emoji ? n.createElement("img", {
    style: _e({
      height: c,
      marginRight: s.right,
      marginLeft: s.left
    }, o && {
      outline: "1px solid var(--color-border-light, rgba(22, 63, 137, 0.15))"
    }),
    className: u,
    alt: f.name,
    src: f.svg
  }) : n.createElement("span", {
    className: u,
    style: {
      fontSize: c
    },
    role: "img",
    "aria-label": f.name
  }, f.emoji) : null;
};

export { oe as C };